import { ALERT_PROCESS_STATUS_SDK } from "lib/constants";
import { sendHttpRequest } from "lib/fetcher";
import { formatAlertTagDisplayToSDK } from "lib/utils";

export function getCaseByAlert(alertId) {
  return sendHttpRequest({
    url: "/case/cases/alert/" + alertId + "?withLocation=true",
    method: "GET",
  });
}
export function getSiteList() {
  return sendHttpRequest({
    url: "/site/tree?withCameraNum=true&withGeolocation=true",
    method: "GET",
  });
}
export function getAlertDetail(alertId: string) {
  return sendHttpRequest({
    url: `/alert/alerts/${alertId}?withLocation=true`,
    method: "GET",
  });
}
export function convertAlertToCase(alertId, tag, otherText) {
  return sendHttpRequest({
    url: `/alert/alerts/${alertId}/change_status`,
    method: "POST",
    data: {
      status: ALERT_PROCESS_STATUS_SDK.Investigate,
      tag: {
        name: formatAlertTagDisplayToSDK(tag),
        desc: otherText,
      },
    },
  });
}

export function subAlerts(sessionId: string) {
  return sendHttpRequest({
    url: `/alert/alerts/sub`,
    method: "POST",
    data: {
      sessionId: sessionId,
    },
  });
}

export function unsubAlerts(sessionId: string) {
  return sendHttpRequest({
    url: `/alert/alerts/unsub`,
    method: "POST",
    data: {
      sessionId: sessionId,
    },
  });
}

export function subAlertWorkflow(alertId: string, sessionId: string) {
  return sendHttpRequest({
    url: `/alert/alerts/${alertId}/sub_wf`,
    method: "POST",
    data: {
      sessionId: sessionId,
    },
  });
}

export function unsubAlertWorkflow(alertId: string, sessionId: string) {
  return sendHttpRequest({
    url: `/alert/alerts/${alertId}/unsub_wf`,
    method: "POST",
    data: {
      sessionId: sessionId,
    },
  });
}

export function reveiveAlertWorkflow(alertId: string, actionId: string) {
  return sendHttpRequest({
    url: `/alert/alerts/${alertId}/receive_wf_act`,
    method: "POST",
    data: {
      actionId: actionId,
    },
  });
}

export function confirmAlertWorkflow(
  alertId: string,
  actionId: string,
  selected: string,
) {
  return sendHttpRequest({
    url: `/alert/alerts/${alertId}/confirm_wf_act_choice`,
    method: "POST",
    data: {
      actionId: actionId,
      selected: selected,
    },
  });
}
export function getVehicleList(params) {
  return sendHttpRequest({
    url: "/alert/alerts/search_cars",
    method: "POST",
    data: { ...params, "page.total": 20 },
  });
}
export function getHeaderStats() {
  return sendHttpRequest({
    url: "/stats/header",
    method: "GET",
  });
}
